module.exports = ({ scope = document } = {}) => {
  const notifications = scope.querySelectorAll('.hse-notification--dismissable')

  const addEvents = () => {
    notifications.forEach((elem) => {
      const closeButton = elem.querySelector('.hse-notification__close-btn')
      closeButton.addEventListener('click', () => {
        elem.remove()
      })
    })
  }

  if (notifications) addEvents()
}
